import React from 'react';
import {FeaturedContentType} from "../../../helpers/featuredContentType";
import {
    Pin,
    Clipboard
} from '_utils/icons';
import PropTypes from 'prop-types';

const icons = {
    [FeaturedContentType.pin]: <Pin color={"#F05F00"}/>,
    [FeaturedContentType.clipboard]: <Clipboard color={"#821846"}/>,
};

export default function FeaturedContentIcon({ icon }) {
    if (icons[icon]) {
        return icons[icon];
    }

    return null;
}

FeaturedContentIcon.propTypes = {
    icon: PropTypes.oneOf(Object.values(FeaturedContentType)).isRequired
};